<style scoped>
  .new_pic{
    position: relative;
    border:1px solid #ddd;

  }
  .new_pic img{
    width:340px;
    height:180px;
  }
  .new_pic h3{
    background-color: rgba(0,0,0,.3);
    font-size:16px;
    color: #fff;
    padding:0 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: absolute;
    bottom:0;
    left:0;
  }
</style>

<template>
    <div id="news" class="everynew">
      <div class="new_pic">
        <router-link :to="{name: 'article-detail', params: {id: id}}">
          <img :src="front_img_path" alt="front">
        </router-link>
        <h3>{{ title }}</h3>
      </div>
      <!--<div id="detail">-->
        <!--<router-link :to="{name: 'article-detail', params: {id: id}}">-->
          <!--<h3>{{ title }}</h3>-->
          <!--<p>{{ summary_display }}</p>-->
        <!--</router-link>-->

        <!--<ul id="tags">-->
          <!--<img src="http://v3.cdn.qiyewan.com/tagtit.png" style="width: 16px;height: 13px;float:left;">-->
          <!--<li class="tag" v-for="item in tags">-->
            <!--<router-link :to="{path: '/articles/list', query: {tag: item.id}}">{{ item.name }}</router-link>-->
          <!--</li>-->
        <!--</ul>-->
        <!--<div class="clearfix"></div>-->
        <!--<div style="width: 100%;">-->
          <!--<span id="time">{{ date | dateFromNowFilter }}</span>-->
          <!--&lt;!&ndash;<span id="views">{{ pv }} 次浏览</span>&ndash;&gt;-->
          <!--<span id="views"> <i class="view_icon"></i>{{ views }} </span>-->
        <!--</div>-->
      <!--</div>-->
    </div>
</template>

<script>
  export default {
    data () {
      return {}
    },
    props: {
      front_img_path: String,
      id: Number,
      title: String,
      summary: String,
      tags: Array,
      date: String,
      views: Number
    },
    computed: {
      summary_display() {
        let summary = this.summary
        if (summary) {
          return summary.length > 30 ? summary.substr(0, 30) + '...' : summary
        }
        else {
          return ''
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// News.vue?22f8ee82